import moment from 'moment';

function initBookingMask() {
    var $bookingForm = $('.js-booking-form');
    let bookingIntentionData;
    var BE = {
        urlParams: function (data) {
            var params = [];
            var languageId = this.getLanguageId(data.locale)
            var date_format = 'MM/DD/YYYY';

            if (data.datein) {
                params.push("datein" + "=" + moment(data.datein, 'DD  MMMM  YYYY').format(date_format));
            }
            if (data.dateout) {
                params.push("dateout" + "=" + moment(data.dateout, 'DD  MMMM  YYYY').format(date_format));
            }

            if (data.rooms) params.push("rooms" + "=" + data.rooms);
            if (data.adults) params.push("adults" + "=" + data.adults);

            if (data.children && data.children > 0) {
                params.push("children" + "=" + data.children);
            }

            if (data.promoCode && data.promoCode.length) {
                params.push("discount" + "=" + data.promoCode);
            }

            if (data.confirmid && data.confirmid.length) {
                params.push("confirmid" + "=" + data.confirmid);
            }

            if (languageId) {
                params.push("languageid=" + languageId);
            }

            bookingIntentionData = {
                dateIn: moment(data.datein, 'DD  MMMM  YYYY').format(date_format), //check in date 
                dateOut: moment(data.dateout, 'DD  MMMM  YYYY').format(date_format), //check out date
                nights: (moment(data.datein, 'DD  MMMM  YYYY')).diff(moment(data.dateout, 'DD  MMMM  YYYY'), 'days'),
                rooms: data.rooms || 0, // number of rooms
                adults: data.adults || 0, // number of adults or 0
                children: data.children || 0, // number of children
                promocode: data.promoCode || 'No code' // promocode value or 'No code'
            };

            try {
                var _ga = window[window['GoogleAnalyticsObject']];
                var linkerParam;
                if (_ga) {
                    linkerParam = _ga.getAll()[0].get('linkerParam');
                    params.push(linkerParam);
                }
            } catch (error) {
                console.warn(error);
            }

            return params.join("&");

        },
        getLanguageId: function (locale) {
            var languageId = '1';
            switch (locale) {
                case 'es':
                    languageId = '2';
                    break;
                case 'fr':
                    languageId = '3';
                    break;
                case 'pt':
                    languageId = '4';
                    break;
                case 'zh-CN':
                    languageId = '5';
                    break;
                case 'ja':
                    languageId = '6';
                    break;
                case 'de':
                    languageId = '7';
                    break;
                case 'it':
                    languageId = '8';
                    break;
                case 'ru':
                    languageId = '9';
                    break;
                case 'nl':
                    languageId = '10';
                    break;
                case 'en':
                    languageId = '11';
                    break;
                case 'hu':
                    languageId = '13';
                    break;
                case 'el':
                    languageId = '14';
                    break;
                case 'ar':
                    languageId = '15';
                    break;
                case 'sv':
                    languageId = '16';
                    break;
                case 'no':
                    languageId = '17';
                    break;
                case 'cs':
                    languageId = '18';
                    break;
                case 'tr':
                    languageId = '19';
                    break;
                case 'ca':
                    languageId = '20';
                    break;
                case 'da':
                    languageId = '21';
                    break;
                case 'id':
                    languageId = '28';
                    break;
                case 'he':
                    languageId = '29';
                    break;
                case 'lt':
                    languageId = '25';
                    break;
                case 'ko':
                    languageId = '26';
                    break;
                case 'pl':
                    languageId = '27';
                    break;
                case 'hr':
                    languageId = '23';
                    break;
                case 'sk':
                    languageId = '24';
                    break;
                case 'lv':
                    languageId = '31';
                    break;
                case 'et':
                    languageId = '30';
                    break;
                case 'ro':
                    languageId = '32';
                    break;
                case 'is':
                    languageId = '33';
                    break;
                case 'fi':
                    languageId = '34';
                    break;
                case 'sl':
                    languageId = '35';
                    break;
                default:
                    languageId = '1';
            }
            return languageId;
        }
    };

    $('.modify').on('submit', function(e, type=""){
        e.preventDefault();

        var arrayData = $(this).serializeArray();
        var data = {}
        arrayData.forEach(function (el) {
            data[el.name] = el.value
        });

        var hotelSelected = $(this).find('.js-bm-select-modify :selected');

        data = {'confirmid': $('input[name="reservation_number"]').val()}
        data.locale = $('html').attr('lang');

        if (hotelSelected.length)
            $(this).attr('action', hotelSelected.val())

        var urlBE = $(this).attr('action'),
        bookingParameters = (BE.urlParams(data)),
        URL;

        if (urlBE.indexOf('#') > -1) {
            var before = urlBE.slice(0, urlBE.indexOf('#')),
            after = urlBE.slice(urlBE.indexOf('#'))
            URL = before + (before.indexOf('?') > -1 ? '&' : '?') + bookingParameters + after
        } else {
            URL = urlBE + (urlBE.indexOf('?') > -1 ? '&' : '?') + bookingParameters
        }
        if(urlBE)
            window.open(URL, '_blank')
            
    });

    $bookingForm.on('submit', function(e, type=""){
        e.preventDefault();
        var arrayData = $(this).serializeArray();
        var data = {}
        arrayData.forEach(function (el) {
            data[el.name] = el.value
        });
        if(!data['promoCode']) {
            data['promoCode'] = $('input[name="promoCode"]').val();
        }

        var hotelSelected = $('.js-bm-hotel-selected', this);

        if(type == 'modify') {
            data = {'confirmid': $('input[name="confirmid"]').val()}
            hotelSelected = $('.js-bm__hotel-modify :selected');
        } else
        delete data['confirmid'];

        data.locale = $('html').attr('lang');

        if (hotelSelected.length)
            $(this).attr('action', hotelSelected.data('url'))

        var urlBE = $(this).attr('action'),
        bookingParameters = (BE.urlParams(data)),
        URL;

        if (urlBE.indexOf('#') > -1) {
            var before = urlBE.slice(0, urlBE.indexOf('#')),
            after = urlBE.slice(urlBE.indexOf('#'))
            URL = before + (before.indexOf('?') > -1 ? '&' : '?') + bookingParameters + after
        } else {
            URL = urlBE + (urlBE.indexOf('?') > -1 ? '&' : '?') + bookingParameters
        }
        if(urlBE)
            window.open(URL, '_blank')
            document.dispatchEvent(new CustomEvent('event.bookingIntention', { detail: bookingIntentionData }));
    });
}

export default initBookingMask;
